import createBaseFetch from '../../lib/Api';

const fetch = createBaseFetch({
  baseURL: process.env.VUE_APP_PLATFORM_SERVICE_URL,
  timeout: 1000000,
});
const customer = createBaseFetch({
  baseURL: process.env.VUE_APP_STATISTICS_SERVER_URL,
  timeout: 1000000,
});

export const fetchRechargeOptions = req =>
  fetch({
    url: '/operateBalance/rechage/initdata',
    method: 'POST',
    ...req,
  });
export const fetchRechargeQRcode = req =>
  fetch({
    url: '/operateBalance/rechage/order',
    method: 'POST',
    ...req,
  });
export const checkOrderState = req =>
  fetch({
    url: '/operateBalance/rechage/sure',
    method: 'POST',
    notLoading: true,
    ...req,
  });
export const rechargeOrder = req =>
  fetch({
    url: '/operateBalance/rechage/order',
    method: 'POST',
    ...req,
  });
export const fetchPlatformMonthList = req =>
  customer({
    url: '/dcxy/platformFee/queryPlatformMonthV2',
    method: 'post',
    ...req,
  });
